// extracted by mini-css-extract-plugin
export default {"description":"ReadMoreButton_description__HmB7d","button":"ReadMoreButton_button__aIv0z","moreText":"ReadMoreButton_moreText__0Bn4n"};